"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosionShoreManagementPlan$ = exports.CoastalErosionShoreManagementPlan$outboundSchema = exports.CoastalErosionShoreManagementPlan$inboundSchema = void 0;
exports.coastalErosionShoreManagementPlanToJSON = coastalErosionShoreManagementPlanToJSON;
exports.coastalErosionShoreManagementPlanFromJSON = coastalErosionShoreManagementPlanFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionestimateddistancelost_js_1 = require("./coastalerosionestimateddistancelost.js");
/** @internal */
exports.CoastalErosionShoreManagementPlan$inboundSchema = z.object({
    estimated_distance_lost: coastalerosionestimateddistancelost_js_1.CoastalErosionEstimatedDistanceLost$inboundSchema,
    id: z.nullable(z.string()),
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "estimated_distance_lost": "estimatedDistanceLost",
    });
});
/** @internal */
exports.CoastalErosionShoreManagementPlan$outboundSchema = z.object({
    estimatedDistanceLost: coastalerosionestimateddistancelost_js_1.CoastalErosionEstimatedDistanceLost$outboundSchema,
    id: z.nullable(z.string()),
    name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        estimatedDistanceLost: "estimated_distance_lost",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosionShoreManagementPlan$;
(function (CoastalErosionShoreManagementPlan$) {
    /** @deprecated use `CoastalErosionShoreManagementPlan$inboundSchema` instead. */
    CoastalErosionShoreManagementPlan$.inboundSchema = exports.CoastalErosionShoreManagementPlan$inboundSchema;
    /** @deprecated use `CoastalErosionShoreManagementPlan$outboundSchema` instead. */
    CoastalErosionShoreManagementPlan$.outboundSchema = exports.CoastalErosionShoreManagementPlan$outboundSchema;
})(CoastalErosionShoreManagementPlan$ || (exports.CoastalErosionShoreManagementPlan$ = CoastalErosionShoreManagementPlan$ = {}));
function coastalErosionShoreManagementPlanToJSON(coastalErosionShoreManagementPlan) {
    return JSON.stringify(exports.CoastalErosionShoreManagementPlan$outboundSchema.parse(coastalErosionShoreManagementPlan));
}
function coastalErosionShoreManagementPlanFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosionShoreManagementPlan$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosionShoreManagementPlan' from JSON`);
}
//# sourceMappingURL=coastalerosionshoremanagementplan.js.map